import React, { useState } from 'react';

import {
  Container,
  CoverContainer,
  PlayButtonContainer,
  PlayButton,
  Label,
  VideoPopupContainer,
  VideoPopup,
  Video,
  ImageShadowContainer,
  LabelShadowContainer,
} from './videoPlayer.styled';
import { VideoPlayerData } from './videoPlayer.types';
import PlayButtonIcon from './images/play.svg';
import { renderWhenTrue } from '@lerna-monorepo/common/utils';

export const VideoPlayer: React.FC<VideoPlayerData> = (data: VideoPlayerData) => {
  const { cover, label, videoId } = data;
  const [isVideoPopupVisible, setIsVideoPopupVisible] = useState(false);

  const renderVideo = renderWhenTrue(() => (
    <Video
      src={`https://www.youtube.com/embed/${videoId}?controls=0`}
      frameBorder="0"
      allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
    />
  ));

  return (
    <Container>
      <CoverContainer background={cover?.localFile?.url}>
        <ImageShadowContainer>
          <LabelShadowContainer>
            <PlayButtonContainer onClick={() => setIsVideoPopupVisible(true)}>
              <PlayButton src={PlayButtonIcon} alt='play button' />
            </PlayButtonContainer>
            <Label>{label}</Label>
          </LabelShadowContainer>
        </ImageShadowContainer>
      </CoverContainer>
      <VideoPopupContainer isVisible={isVideoPopupVisible}  onClick={() => setIsVideoPopupVisible(false)}>
        <VideoPopup>
          {renderVideo(isVideoPopupVisible)}
        </VideoPopup>
      </VideoPopupContainer>
    </Container>
  );
};
